import React, { useState } from 'react';
import cx from 'classnames';

import InfoCardList, { InfoCardListProps } from '../InfoCardList';

import { Body1, Heading6, Tag } from '../Typography';

import styles from './index.module.scss';

export interface InfoCardListSelectionOption {
  id: string;
  label: string;
  cards: InfoCardListProps['cards'];
}

export interface InfoCardListSelectionProps {
  title?: string;
  description?: string;
  options: InfoCardListSelectionOption[];
  defaultSelectedId?: string;
  className?: string;
}

const InfoCardListSelection: React.FC<InfoCardListSelectionProps> = ({
  title,
  description,
  options,
  defaultSelectedId,
  className,
}) => {
  const [selectedId, setSelectedId] = useState(
    defaultSelectedId || options[0]?.id,
  );

  const selectedOption = options.find((option) => option.id === selectedId);

  if (!selectedOption) return null;

  return (
    <div className={cx(styles.wrapper, className)}>
      {title && <Heading6 className={styles.title}>{title}</Heading6>}
      {description && (
        <Body1 className={styles.description}>{description}</Body1>
      )}

      <div className={styles.tabs}>
        {options.map((option) => {
          const isActive = option.id === selectedId;

          return (
            <button
              key={option.id}
              type='button'
              className={cx(styles.tab, {
                [styles.activeTab]: isActive,
              })}
              onClick={() => setSelectedId(option.id)}
            >
              <Tag>{option.label}</Tag>
            </button>
          );
        })}
      </div>

      <InfoCardList cards={selectedOption.cards} />
    </div>
  );
};

export default InfoCardListSelection;
